import React, { useState, useEffect } from 'react';
import TabManager from './components/TabManager';
import './App.css';
import Navbar from './components/Navbar';

function App() {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    
    // Prevent scrolling on iOS
    document.body.addEventListener('touchmove', (e) => {
      e.preventDefault();
    });

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      <Navbar />
      <TabManager />
    </div>
  );
}

export default App;
